import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import Chip from '../Chip';
import { fontSize, radius, space } from '../../style/utils';

const ChangesList = styled(Stack)`
  border-radius: ${radius('lg')};
  border: ${({ theme }) => `1px solid ${theme.palette.border.muted}`};
  background-color: ${({ theme }) => theme.palette.surface.subtle};
`;

const Item = styled(Stack)`
  padding: ${space('mdPlus')};

  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.border.muted}`};
  }
`;

type Props = {
  displayName: string;
  description: string | undefined;
};

const SchemaChangesList = ({ displayName, description }: Props) => (
  <ChangesList>
    <Item>
      <Typography sx={{ fontSize: fontSize('md'), color: 'content.secondary' }}>
        Schema change
      </Typography>
    </Item>
    <Item>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Typography sx={{ fontSize: fontSize('md'), whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
        <Chip label={displayName} color="error" />
      </Stack>
    </Item>
  </ChangesList>
);

export default SchemaChangesList;
